/** API レスポンスの共通型 */
export interface ApiResponse<T> {
  code: number;
  data: T;
}

/** API エラーコード定数 */
export const API_ERROR_CODES = {
  SUCCESS: 0,
  UNKNOWN: 1,
  INVALID_TOKEN: 3,
  EMAIL_NOT_FOUND: 10,
  INCORRECT_PASSWORD: 21,
  NOT_ENOUGH_POINT: 70,
  LOCKED_USER: 81,
  CALL_PERMISSION_OFF: 82,
  PARTNER_NOT_WAITING: 83,
  PARTNER_IS_NOW_CALLING: 85,
  PARTNER_BROADCASTING: 89,
  USER_ALREADY_REGISTERED: 9205,
  CALL_NOT_IN_PROGRESS: 9320,
} as const;

/** API エラークラス */
export class ApiError extends Error {
  code: number;

  constructor(code: number, message: string) {
    super(message);
    this.name = "ApiError";
    this.code = code;
  }
}
